import { Radar, ReceiptText, CheckCircle2, Send } from "lucide-react";
import { fmtUSD } from "@/lib/api";

const CARDS = [
  {
    key: "active", icon: Radar, tint: "#7FAEF9", bg: "rgba(79,142,247,0.12)", label: "Active chases",
    value: (s) => s.active_chases, sub: (s) => (s.escalated ? `${s.escalated} escalated to you` : "all running on autopilot"), pulse: true,
  },
  {
    key: "outstanding", icon: ReceiptText, tint: "#FBBF24", bg: "rgba(245,158,11,0.12)", label: "Receipts outstanding",
    value: (s) => fmtUSD(s.outstanding_amount), sub: (s) => `${s.outstanding_count} receipt${s.outstanding_count === 1 ? "" : "s"} owed`,
  },
  {
    key: "recovered", icon: CheckCircle2, tint: "#4ADE80", bg: "rgba(34,197,94,0.12)", label: "Recovered · 30d",
    value: (s) => s.recovered_30d, sub: () => "receipts Aria brought home",
  },
  {
    key: "nudges", icon: Send, tint: "#c9c9c9", bg: "rgba(255,255,255,0.06)", label: "Nudges sent · 7d",
    value: (s) => s.nudges_7d, sub: () => "across Slack, Teams, email & text",
  },
];

export const ChaseStats = ({ stats }) => (
  <div className="grid grid-cols-2 gap-3 xl:grid-cols-4" data-testid="chase-stats">
    {CARDS.map(({ key, icon: Icon, tint, bg, label, value, sub, pulse }) => (
      <div key={key} className="rounded-[14px] border border-[#222] bg-[#111111] p-4 card-shadow" data-testid={`chase-stat-${key}`}>
        <div className="flex items-center gap-2">
          <span className="flex h-7 w-7 items-center justify-center rounded-lg" style={{ background: bg, color: tint }}>
            <Icon size={14} />
          </span>
          <span className="text-[10.5px] font-semibold uppercase tracking-wider text-[#6b6b6b]">{label}</span>
          {pulse && <span className="ml-auto h-1.5 w-1.5 rounded-full bg-[#22C55E] pulse-dot" />}
        </div>
        <div className="mt-2.5 text-[22px] font-semibold tabular-nums leading-none text-white">{value(stats)}</div>
        <div className="mt-1.5 text-[10.5px] text-[#6b6b6b]">{sub(stats)}</div>
      </div>
    ))}
  </div>
);
